import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import GlobalSection from '../../components/basics/global/GlobalSection';
import TeaserWrapper from '../../components/compositions/teaser/TeaserWrapper';
import Teaser from '../../components/compositions/teaser/Teaser';

function TeaserInfo({ params, layoutSettings, primaryModule, location, behaviorSettings }) {
  const { type, headline, group, footer, colorScheme } = params;
  const inverted = colorScheme === 'dark';
  return (
    <GlobalSection
      layout="expanded"
      theme={colorScheme}
      layoutSettings={layoutSettings}
    >
      <TeaserWrapper
        primaryModule={primaryModule}
        type={type}
        title={headline}
        footer={footer}
        theme={colorScheme}
        adjacent
        headlineLevel={behaviorSettings?.headlineLevel}
      >
        {group.map((item, index) => (
          <Teaser
            {...item}
            type={type}
            inverted={inverted}
            key={index}
            location={location}
          />
        ))}
      </TeaserWrapper>
    </GlobalSection>
  );
}

TeaserInfo.propTypes = {
  params: PropTypes.object.isRequired,
  layoutSettings: PropTypes.object,
  behaviorSettings: PropTypes.object,
  primaryModule: PropTypes.bool.isRequired,
  location: PropTypes.object,
};

const mapStateToProps = ({ routing }) => ({
  location: routing.locationBeforeTransitions,
});

export default connect(mapStateToProps)(TeaserInfo);
